import { CopyButton } from '@/components/ui/CopyButton'
import { FileChip } from '@/components/ui/file-chip'
import { Demo, DsSection } from '../primitives'

const DETAILS: { name: string; detail: string }[] = [
  { name: 'acme-settlement-week-42.pdf', detail: '2 pages' },
  { name: 'fleet-roster.xlsx', detail: '3 sheets' },
]

const STATES: { prop: string; chip: React.ReactNode }[] = [
  {
    prop: 'onRemove={remove}',
    chip: <FileChip name="fuel-october.csv" onRemove={() => {}} />,
  },
  { prop: 'uploading', chip: <FileChip name="rate-confirmation.pdf" uploading /> },
  {
    prop: 'removing',
    chip: <FileChip name="bank-statement.pdf" detail="4 pages" removing onRemove={() => {}} />,
  },
]

function Labeled({ value, children }: { value: string; children: React.ReactNode }) {
  return (
    <div className="flex flex-col items-start gap-2">
      {children}
      <div className="text-ink-400 flex items-center gap-1 font-mono text-[10px]">
        <span>{value}</span>
        <CopyButton
          value={value}
          className="text-ink-400 hover:text-ink size-4 bg-transparent hover:bg-transparent"
        />
      </div>
    </div>
  )
}

export function FileChipSection() {
  return (
    <DsSection id="file-chip" title="File chip">
      <Demo label="Detail" className="flex flex-wrap items-start gap-6">
        {DETAILS.map(({ name, detail }) => (
          <Labeled key={name} value={`detail="${detail}"`}>
            <FileChip name={name} detail={detail} />
          </Labeled>
        ))}
      </Demo>
      <Demo label="States" className="flex flex-wrap items-start gap-6">
        {STATES.map(({ prop, chip }) => (
          <Labeled key={prop} value={prop}>
            {chip}
          </Labeled>
        ))}
      </Demo>
    </DsSection>
  )
}
